export default {
  labelField: {
    marginBottom: 0
  }
};